import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n, { applyDirection } from './i18n'
import { installGlobalErrorReporting } from './services/errorReporter'
import { installReviewTelemetryTransport } from './services/reviewTelemetryTransport'

applyDirection()

const app = createApp(App)

// Global error capture: uncaught Vue/runtime/promise errors are reported to the backend so an operator-side
// crash is observable, not silent. The ErrorBoundary around <router-view> shows a recoverable fallback.
installGlobalErrorReporting(app)

// The review workbench's telemetry sink. `useReviewTelemetry` ships with NO transport so that a page never
// emits into a void; this single call is what turns every existing call site on. Without it the funnel at
// /analytics/review-telemetry is empty for ever — and empty is indistinguishable from «nobody worked».
installReviewTelemetryTransport()

app.use(i18n)
app.use(router)

app.mount('#app')
